// extracted by mini-css-extract-plugin
export default {"wrapper":"YoutubeChannelInfo_wrapper__bfvDQ","subcriber":"YoutubeChannelInfo_subcriber__Br8K9","view":"YoutubeChannelInfo_view__JDMO1"};